import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from "@chakra-ui/react";
export var ShChevronRightIcon = createIcon({
    displayName: "Chevron Right",
    viewBox: "0 0 6 10",
    path: (_jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0.292894 9.70711C-0.0976305 9.31658 -0.0976305 8.68342 0.292894 8.29289L3.58579 5L0.292893 1.70711C-0.0976315 1.31658 -0.0976315 0.683417 0.292892 0.292893C0.683417 -0.0976315 1.31658 -0.0976315 1.70711 0.292893L5.70711 4.29289C5.89464 4.48043 6 4.73478 6 5C6 5.26522 5.89464 5.51957 5.70711 5.70711L1.70711 9.70711C1.31658 10.0976 0.683418 10.0976 0.292894 9.70711Z", fill: "currentColor" })),
    defaultProps: {
        "aria-label": "Chevron Right icon",
        role: "img",
    },
});
